import React, { useEffect, useRef, useState } from 'react';
import { loadGoogleMapsScript } from './maps_loader';

export const SingleLocationMap = ({ title, address, lat, lng, height = '260px' }) => {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const placePin = (position) => {
      if (cancelled || !mapRef.current) return;
      if (!mapInstance.current) {
        mapInstance.current = new window.google.maps.Map(mapRef.current, {
          center: position,
          zoom: 15,
          disableDefaultUI: true,
          zoomControl: true,
        });
      } else {
        mapInstance.current.setCenter(position);
      }
      if (markerRef.current) markerRef.current.setMap(null);
      markerRef.current = new window.google.maps.Marker({
        position,
        map: mapInstance.current,
      });
    };

    const hasCoords = typeof lat === 'number' && typeof lng === 'number' && !isNaN(lat) && !isNaN(lng);
    if (hasCoords || address) setError(null);

    const init = async () => {
      try {
        await loadGoogleMapsScript();
        if (cancelled) return;

        if (hasCoords) {
          placePin({ lat, lng });
          return;
        }
        if (address) {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ address }, (results, status) => {
            if (cancelled) return;
            if (status === 'OK' && results[0]) {
              const loc = results[0].geometry.location;
              placePin({ lat: loc.lat(), lng: loc.lng() });
            } else {
              setError('Could not locate address');
            }
          });
          return;
        }
        setError('No location data');
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load map');
      }
    };

    init();
    return () => { cancelled = true; };
  }, [address, lat, lng]);

  return (
    <div style={{ flex: '1 1 320px', minWidth: '280px' }}>
      {title && <p className="fieldLabel" style={{ marginBottom: '6px' }}>{title}</p>}
      <div style={{ position: 'relative', height }}>
        <div ref={mapRef} style={{ width: '100%', height, borderRadius: '8px' }} />
        {error && (
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5', borderRadius: '8px', color: '#666', fontSize: '13px' }}>
            {error}
          </div>
        )}
      </div>
    </div>
  );
};
